import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { routeKey } from '@drapejs/core';
import { computed, inject } from 'vue';
import KlarnaReceipt from './KlarnaReceipt.vue';
import NativeReceipt from './NativeReceipt.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Receipt',
  setup(__props) {

const route = inject(routeKey);
const isKlarnaReceipt = computed(() => route?.query.accountId && route.query.transactionNumber);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isKlarnaReceipt))
      ? (_openBlock(), _createBlock(KlarnaReceipt, { key: 0 }))
      : _createCommentVNode("", true),
    (!_unref(isKlarnaReceipt))
      ? (_openBlock(), _createBlock(NativeReceipt, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})